class UsefulWidget {
    constructor() {
        this.user = new User();
        this.psr = {
            0: null,
            1: "No",
            2: null,
            3: "Meh",
            4: null,
            5: "Yes",
        }
        this.init();
    }
    init() {
        document.querySelectorAll('.isituseful .useful').forEach(item => {
            item.addEventListener("click", event => {
                event.preventDefault();
                document.querySelectorAll('.isituseful .useful button').forEach(item => {
                    item.setAttribute("disabled", true)
                });



                document.querySelector('.is-useful-info').classList.remove("active","mdn-isOpen");
                document.querySelector('.why-not-useful-info').classList.remove("active","mdn-isOpen");
                document.querySelector('#why-not-useful').classList.remove('sent');


                let rate = 0;
                if (event.currentTarget.classList.contains('disabled')) return;
                document.querySelectorAll('.isituseful .useful').forEach(item => {
                    item.classList.remove("active")
                });

                if (event.currentTarget.classList.contains('useful-yes')) {
                    document.querySelector('.is-useful-info').classList.add("active", "mdn-isOpen");
                    setTimeout(() => {
                        document.querySelector('.is-useful-info').classList.remove("active", "mdn-isOpen");
                        document.querySelectorAll('.isituseful .useful button').forEach(item => {
                            item.removeAttribute("disabled")
                        });        
                    }, 4000)
                    document.querySelector('#why-not-useful').classList.add('sent');
                    document.querySelector('#why-not-useful').classList.remove('active');
                    rate = 5;
                } else {
                    setTimeout(() => {
                        document.querySelectorAll('.isituseful .useful button').forEach(item => {
                            item.removeAttribute("disabled")
                        });        
                    }, 1000)                 
                    rate = 1;
                    document.querySelector('#why-not-useful').classList.add('active');
                    document.querySelector('textarea[name="why-not-useful"').focus();
                    document.querySelector('.buttons').scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                event.currentTarget.classList.add("active");
                const data = {
                    "topicId": QelpCareHUB.selected.usecase.id,
                    "userhash": this.user.data.id,
                    "rating": rate,
                };
                this.user.vote({
                    hashkey: sha256(QelpCareHUB.uri),
                    rating: rate
                });
                if (window.dataLayer) {
                    window.dataLayer.push({
                        'topicRating': rate,
                        'problemResolutionScore': this.psr[rate]
                    });
                }
                eHelpFramework.call('ratings', null, 'POSTJSON', data);
            });
        });

        document.querySelector('.why-not-useful-send').addEventListener('click', event => {
            event.preventDefault();
            if (document.querySelector("#why-not-useful textarea").value.length == 0) return;
            if (event.currentTarget.classList.contains('disabled')) return;

            document.querySelectorAll('.isituseful .useful button').forEach(item => {
                item.setAttribute("disabled", true)
            });


            document.querySelector('.why-not-useful-info').classList.add("active", "mdn-isOpen");
            setTimeout(() => {
                document.querySelector('.why-not-useful-info').classList.remove("active", "mdn-isOpen");
                document.querySelectorAll('.isituseful .useful button').forEach(item => {
                    item.removeAttribute("disabled")
                });                
            }, 4000)
            document.querySelector('#why-not-useful').classList.remove('active');
            document.querySelector('#why-not-useful').classList.add('sent');
            const data = {
                "topicId": Number(QelpCareHUB.selected.usecase.id),
                "userhash": this.user.data.id,
                "comment": document.querySelector("#why-not-useful textarea").value,
            }

            if (window.dataLayer) {
                window.dataLayer.push({
                    'whyNotUseful': document.querySelector("#why-not-useful textarea").value
                });
                window.dataLayer.push({event: "commentPRS", whyNotUseful: document.querySelector("#why-not-useful textarea").value})                
            }
            eHelpFramework.call(`${QelpCareHUB.api}comments`,
                e => {

                }, "POSTJSON", data);
        });
        // document.querySelector('.why-not-useful-info .close').addEventListener("click", (e) => {
        //     document.querySelector('.why-not-useful-info').classList.remove("active");
        // });
        let please_help_me = document.querySelector(".please-help-me");

        if (please_help_me) {
            please_help_me.addEventListener("click", e => {
                document.querySelector(".please-help-me").classList.add("hidden");
                document.querySelector(".why-not-useful-send").classList.add("hidden");
                document.querySelector("#why-not-useful .callme-name").classList.remove("hidden");
                document.querySelector("#why-not-useful .callme-number").classList.remove("hidden");
                document.querySelector(".please-help-me-send").classList.remove("hidden");
            });
            document.querySelector(".please-help-me-send").addEventListener("click", e => {
                let user = document.querySelector("#why-not-useful .callme-name").value;
                let to = document.querySelector("#why-not-useful .callme-number").value;
                e.currentTarget.innerHTML = '<i class="material-icons">loop</i> Enviando';

                let Parameters = {
                    "user": user,
                    "deviceType": QelpCareHUB.selected.device.type ? QelpCareHUB.selected.device.type.name : "",
                    "vendor": QelpCareHUB.selected.manufacturer.name,
                    "device": QelpCareHUB.selected.device.name,
                    "topic": QelpCareHUB.selected.usecase.topicName
                };

                let data = {
                    "To": to,
                    "From": "+5511933058329",
                    "Parameters": JSON.stringify(Parameters)
                }
                eHelpFramework.call("https://studio.twilio.com/v1/Flows/FWfee4dd94013656bc0301325976764040/Executions",
                    e => {
                        document.querySelector(".please-help-me-send").innerHTML = "Enviado!";
                        setTimeout(() => {
                            document.querySelector(".please-help-me-send").innerHTML = "Enviar";
                        }, 1000);
                    }, "POST", data, { "name": "Authorization", "key": "Basic QUMzNzMzM2JjYjZkMjc1ODAzMzIwYWM3MmRhMWU5ZTY3ZToxM2ZhZTljMjQ1ZjFjMTY4YjU5Yjg0NjEwODBhZWNkNQ==" });
            });
        }
    }
}

window.addEventListener("eHelpFrameworkReady", e => {
    eHelpFramework.widgets.push(new UsefulWidget())
});